angular.module('ihestiaWidgets.policyDetails')
  .controller('ihestiaBeneficiaryListModalCtrl', ['$scope', 'ihestiaBeneficiaryListModalHelper',
    function($scope, ihestiaBeneficiaryListModalHelper) {
      $scope.tplData = ihestiaBeneficiaryListModalHelper.tplData;
      $scope.init = ihestiaBeneficiaryListModalHelper.initData;

      $scope.init();
    }]);
